import { createSelector } from '@reduxjs/toolkit';
import { getProfileState } from './getProfileState';

export const getProfile = createSelector(getProfileState, (state) => state?.profile);
